import * as React from 'react';
import { Sticky, PricePerLiter, QuantitySelector, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, useCmsData, ProductDetailTitleView, ProductDetailPrice, ProductDiscountLabel, Discount, ProductDetailUsps, ProductDetailDisclaimer } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { Description } from './Components/Description/Description.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';

const Solutions = ({ addToCartRef , availableQuantity , ctaButton , stickyTop , currency , brandLink , isSmallScreen , isProductLabelEnabled , labels , showStickyButton , variant , brandModel , packageSelector , selectedQuantity , onDecreaseQuantity , onIncreaseQuantity , isOrderable , maxOrderableQuantity , quantity ,  })=>{
    var ref, ref1, ref2;
    const { isDeliveryFullDateEnabled , isPricePerLiterEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { disclaimer , usps: productTypeUsps  } = useCmsData();
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-solutions"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.modelName} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    })), !isProductLabelEnabled && ((ref = variant.tag) === null || ref === void 0 ? void 0 : ref.value) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), !!variant.price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: variant.price.originalPrice,
        discountedPrice: variant.price.discountedPrice,
        currency: currency
    })), isPricePerLiterEnabled && ((ref1 = variant.pricePerLiter) === null || ref1 === void 0 ? void 0 : ref1.amount) && ((ref2 = variant.pricePerLiter) === null || ref2 === void 0 ? void 0 : ref2.currencyCode) && /*#__PURE__*/ React.createElement(PricePerLiter, {
        amount: variant.pricePerLiter.amount,
        currencyCode: variant.pricePerLiter.currencyCode
    }), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    }), packageSelector, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__label"
    }, labels.selectAmount), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: maxOrderableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isDisabled: !isOrderable
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: availableQuantity,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "text",
        items: [
            {
                sku: variant.sku,
                quantity
            }
        ]
    })), /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, ctaButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && variant.price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice,
            currency: currency,
            centAmount: true
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, null))))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__description"
    }, /*#__PURE__*/ React.createElement(Description, null)), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, null)));
};
var Solutions$1 = Solutions;

export { Solutions, Solutions$1 as default };
//# sourceMappingURL=Solutions.js.map
